<template>
    <span
        v-b-tooltip.hover="
            isAdminRole
                ? {
                      placement: 'top',
                      title: `Administrator's permissions are all enabled and cannot be updated`
                  }
                : null
        "
        class="role"
    >
        <button
            type="button"
            class="btn btn-secondary"
            :class="{ active: role.name === selectedRole.name }"
            @click="onRoleClick(role)"
            :disabled="!isHasAccessToPermission || isAdminRole"
        >
            {{ role.name }} ({{ role.staff_count }})
        </button>
    </span>
</template>
<script>
export default {
    components: {},
    props: {
        role: {
            type: Object,
            default: null
        },
        selectedRole: {
            type: Object,
            default: null
        },
        isHasAccessToPermission: {
            type: Boolean,
            default: false
        },
        changeSelectedRole: {
            type: Function
        }
    },
    data() {
        return {};
    },
    computed: {
        isAdminRole() {
            return this.role.name.toLowerCase() === "administrator";
        }
    },
    methods: {
        async onRoleClick(role) {
            if (this.AdminRole || !this.changeSelectedRole) return;
            this.changeSelectedRole(role);
        }
    }
};
</script>
<style scoped lang="scss">
.role-group {
    .role {
        .btn {
            position: relative;
            -webkit-box-flex: 1;
            flex: 1 1 auto;
        }

        &:not(:first-child) {
            .btn {
                border-top-left-radius: 0px;
                border-bottom-left-radius: 0px;
                margin-left: -1px;
            }
        }

        &:not(:last-child) {
            .btn {
                border-top-right-radius: 0px;
                border-bottom-right-radius: 0px;
            }
        }

        .btn.active {
            z-index: 1;
        }

        .btn:disabled {
            cursor: not-allowed;
        }
    }
}
</style>
